import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import InspectionAction from 'store/inspection-resource/actions';

function ModalRemarks({ toggle, isOpen, validation, selectedInspection }) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  const onSave = () => {
    dispatch(InspectionAction.postOrderMemo({ id: selectedInspection, remarks: validation.values.remarks }, callbackSave))
  }

  const callbackSave = () => {
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>備考</ModalHeader>
      <ModalBody>
        <Input
          name='remarks'
          type='textarea'
          value={validation.values.remarks || ''}
          onChange={validation.handleChange}
        />
      </ModalBody>
      <ModalFooter>
        {
          store.inspection.postMemo.loading ? <Skeleton width={100} height={30} /> : <Button type='button' color='primary' onClick={onSave}>保存</Button>
        }

      </ModalFooter>
    </Modal>
  );
}

export default ModalRemarks;